<template>
  <div class="row">
    <card
      type="tasks"
      class="col-sm"
      style="height: auto; padding-bottom: 30px"
    >
      <template slot="header">
        <div style="">
          <div class="row">
            <div class="">
              <h4 class="title d-inline">套餐管理</h4>
            </div>
            <div class="ml-auto">
              <div>
                <base-button
                  style="margin-right: 10px"
                  size="sm"
                  type="danger"
                  @click="handleAddPackage"
                  >添加套餐</base-button
                >
              </div>
            </div>
          </div>
        </div>
        <div style="margin-top: 20px">
          <base-table :data="tableData" :columns="columns">
            <template slot="columns">
              <th>id</th>
              <th>套餐名称</th>
              <th>套餐对应网站数量</th>
              <th>套餐时间</th>
              <th>套餐价格</th>
              <th>前端在线支付状态</th>
              <th>套餐类型</th>
              <th>激活码类型</th>
              <th>VIP类型</th>
              <th>代理开卡状态</th>
              <th>套餐排序</th>
              <th class="text-right">操作</th>
            </template>
            <template slot-scope="{ row }">
              <td>{{ row.id }}</td>
              <td>{{ row.name }}</td>
              <td>{{ row.site_num }}</td>
              <td>{{ row.duration }}</td>
              <td>{{ row.price }}</td>
              <td>
                  <el-tooltip
                  :content="
                    row.state === 1 ? '已开启在线支付' : '已关闭在线支付'
                  "
                  placement="top"
                >
                  <el-switch
                    v-model="row.state"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    :active-value="1"
                    :inactive-value="0"
                    @change="changePackageState(row.id)"
                  >
                  </el-switch>
                </el-tooltip>


              </td>
              <td>
                <badge type="default" v-if="row.package_type == 1"
                  >时间套餐</badge
                >
                <badge type="danger" v-if="row.package_type == 2"
                  >次数套餐</badge
                >
                <badge type="info" v-if="row.package_type == 3"
                  >积分套餐</badge
                >
              </td>
              <td>
                <badge type="info" v-if="row.cdk_type == 1">普通套餐</badge>
                <badge type="danger" v-if="row.cdk_type == 2">自选套餐</badge>
              </td>
                <td>
                <badge type="success" v-if="row.vip_type == 1">个人VIP</badge>
                <badge type="default" v-if="row.vip_type == 2">企业VIP</badge>
              </td>
              <td>
                <el-tooltip
                  :content="
                    row.agent_state === 1 ? '代理可购买' : '代理不可购买'
                  "
                  placement="top"
                >
                  <el-switch
                    v-model="row.agent_state"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    :active-value="1"
                    :inactive-value="0"
                    @change="updateAgentState(row)"
                  >
                  </el-switch>
                </el-tooltip>
              </td>
              <td>{{ row.sort }}</td>
              <td class="text-right">
                <base-button
                  type="success"
                  style="margin-left: 6px"
                  size="sm"
                  icon
                  @click="
                    editPackage(
                      row.id,
                      row.name,
                      row.site_num,
                      row.duration,
                      row.price,
                      row.package_type,
                      row.cdk_type,
                      row.vip_type
                    )
                  "
                >
                  <i style="color: #ffffff" class="tim-icons icon-settings"></i>
                </base-button>
                <base-button
                  type="danger"
                  style="margin-left: 6px"
                  size="sm"
                  icon
                >
                  <i
                    style="color: #ffffff"
                    class="tim-icons icon-simple-remove"
                  ></i>
                </base-button>
              </td>
            </template>
          </base-table>
        </div>
      </template>
      <div>
        <modal :show.sync="modals" headerClasses="justify-content-center">
          <h4 slot="header" class="title title-up">添加套餐</h4>
          <base-input
            label="套餐名称"
            type="text"
            placeholder="请输入套餐名称"
            v-model="packageName"
          ></base-input>
          <base-input
            label="套餐网站数量"
            type="text"
            placeholder="请输入套餐网站数量"
            v-model="siteNum"
          ></base-input>
          <base-input
            label="套餐时间(天)"
            type="text"
            placeholder="请输入套餐时间"
            v-model="packageDuration"
          ></base-input>
          <base-input
            label="套餐价格"
            type="text"
            placeholder="请输入套餐价格"
            v-model="packagePrice"
          ></base-input>

          <div>套餐类型</div>
          <div>
            <el-select
              class="select-danger"
              placeholder="请选择套餐类型"
              v-model="selects.simple"
              style="margin-top: 8px; width: 100%"
            >
              <el-option
                v-for="option in selects.languages"
                class="select-danger"
                :value="option.value"
                :label="option.label"
                :key="option.label"
              >
              </el-option>
            </el-select>
          </div>

           <div style="margin-top: 8px">VIP类型</div>
          <div>
            <el-select
              class="select-danger"
              placeholder="请选择VIP类型"
              v-model="selects5.simple"
              style="margin-top: 8px; width: 100%"
            >
              <el-option
                v-for="option in selects5.languages"
                class="select-danger"
                :value="option.value"
                :label="option.label"
                :key="option.label"
              >
              </el-option>
            </el-select>
          </div>

          <div style="margin-top: 8px">激活码类型</div>
          <div>
            <el-select
              class="select-danger"
              placeholder="请选择激活码类型"
              v-model="selects3.simple"
              style="margin-top: 8px; width: 100%"
            >
              <el-option
                v-for="option in selects3.languages"
                class="select-danger"
                :value="option.value"
                :label="option.label"
                :key="option.label"
              >
              </el-option>
            </el-select>
          </div>

          <div style="margin-top: 8px">选择网站</div>
          <el-select
            multiple
            class="select-primary"
            collapse-tags
            v-model="selects1.multiple"
            placeholder="请选择套餐网站"
            style="margin-top: 8px; width: 100%"
          >
            <el-option
              v-for="option in selects1.languages"
              class="select-primary"
              :value="option"
              :label="option.label"
              :key="option.label"
            >
            </el-option>
          </el-select>

          <card class="row" style="height: auto">
            <div
              v-for="pkg in selects1.multiple"
              :key="pkg.value"
              style="
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-top: 15px;
              "
            >
              <div style="flex: 1">
                <badge type="default">{{ pkg.label }}</badge>
              </div>
              <el-input-number
                style="flex: 2; width: 10%"
                v-model="packageCounts[pkg.value]"
                :min="1"
              />
            </div>
          </card>
          <div style="margin-top: 18px"></div>
          <template slot="footer">
            <base-button @click="doAddPackage">确定</base-button>
            <base-button type="danger" @click.native="modals = false"
              >取消
            </base-button>
          </template>
        </modal>
      </div>
      <div>
        <modal :show.sync="modals1" headerClasses="justify-content-center">
          <h4 slot="header" class="title title-up">编辑套餐</h4>
          <base-input
            label="套餐名称"
            type="text"
            placeholder="请输入套餐名称"
            v-model="editPackageName"
          ></base-input>
          <base-input
            label="套餐网站数量"
            type="text"
            placeholder="请输入套餐网站数量"
            v-model="editSiteNum"
          ></base-input>
          <base-input
            label="套餐时间(天)"
            type="text"
            placeholder="请输入套餐时间"
            v-model="editPackageDuration"
          ></base-input>
          <base-input
            label="套餐价格"
            type="text"
            placeholder="请输入套餐价格"
            v-model="editPackagePrice"
          ></base-input>

          <div>套餐类型</div>
          <div>
            <el-select
              class="select-danger"
              placeholder="请选择套餐类型"
              v-model="selects2.simple"
              style="margin-top: 8px; width: 100%"
            >
              <el-option
                v-for="option in selects2.languages"
                class="select-danger"
                :value="option.value"
                :label="option.label"
                :key="option.label"
              >
              </el-option>
            </el-select>
          </div>

          <div style="margin-top: 8px">激活码类型</div>
          <div>
            <el-select
              class="select-danger"
              placeholder="请选择激活码类型"
              v-model="selects4.simple"
              style="margin-top: 8px; width: 100%"
            >
              <el-option
                v-for="option in selects4.languages"
                class="select-danger"
                :value="option.value"
                :label="option.label"
                :key="option.label"
              >
              </el-option>
            </el-select>
          </div>


                     <div style="margin-top: 8px">VIP类型</div>
          <div>
            <el-select
              class="select-danger"
              placeholder="请选择VIP类型"
              v-model="selects5.simple"
              style="margin-top: 8px; width: 100%"
            >
              <el-option
                v-for="option in selects5.languages"
                class="select-danger"
                :value="option.value"
                :label="option.label"
                :key="option.label"
              >
              </el-option>
            </el-select>
          </div>

          <card class="row" style="height: auto">
            <div
              v-for="pkg in updatePackageList"
              :key="pkg.id"
              style="
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-top: 15px;
              "
            >
              <div style="flex: 1">
                <badge type="default">{{ pkg.name }}</badge>
              </div>
              <el-input-number
                style="flex: 2; width: 10%"
                v-model="pkg.day_num"
                :min="1"
              />
              <base-button
                v-if="pkg.package_site_state == 0"
                style="margin-left: 6px"
                size="sm"
                round
                icon
                type="danger"
                @click="updataPackageSiteState(pkg.id)"
                ><i class="tim-icons icon-button-pause"></i
              ></base-button>
              <base-button
                v-if="pkg.package_site_state == 1"
                style="margin-left: 6px"
                size="sm"
                round
                icon
                type="success"
                @click="updataPackageSiteState(pkg.id)"
                ><i class="tim-icons icon-triangle-right-17"></i
              ></base-button>
            </div>
          </card>
          <div style="margin-top: 18px"></div>
          <template slot="footer">
            <base-button @click="doEditPackage">确定</base-button>
            <base-button type="danger" @click.native="modals1 = false"
              >取消
            </base-button>
          </template>
        </modal>
      </div>
    </card>
  </div>
</template>
<script>
import BaseTable from "@/components/BaseTable";
import Badge from "@/components/Badge";
import { http } from "../../util/http.js";
import Modal from "@/components/Modal";
import {ElTooltip, ElSwitch,Select, Option } from "element-ui";
import Swal from "sweetalert2";

export default {
  components: {
    BaseTable,
    Badge,
    Modal,
    [Select.name]: Select,
    [Option.name]: Option,
  },
  data() {
    return {
      value: "可购买",
      packageName: "",
      siteNum: "",
      packageDuration: "",
      packagePrice: "",
      editPackageName: "",
      editPackageDuration: "",
      editPackagePrice: "",
      editSiteNum: "",
      packageId: "",
      columns: ["id", "color", "content", "add_time", "actions"],
      tableData: [],
      packageSIte: [],
      updatePackageList: [],
      modals: false,
      modals1: false,
      selects: {
        simple: "",
        languages: [
          { value: "1", label: "时间套餐" },
          { value: "2", label: "次数套餐" },
          { value: "3", label: "积分套餐" },
        ],
      },
      selects3: {
        simple: "",
        languages: [
          { value: "1", label: "普通套餐" },
          { value: "2", label: "自选套餐" },
        ],
      },
      selects4: {
        simple: "时间套餐",
        languages: [
          { value: "1", label: "普通套餐" },
          { value: "2", label: "自选套餐" },
        ],
      },
      selects5: {
        simple: "",
        languages: [
          { value: "1", label: "个人VIP" },
          { value: "2", label: "企业VIP" },
        ],
      },
      selects1: {
        languages: [],
        multiple: "",
      },
      selects2: {
        simple: "时间套餐",
        languages: [
          { value: "1", label: "时间套餐" },
          { value: "2", label: "次数套餐" },
          { value: "3", label: "积分套餐" },
        ],
      },
      selectedPackages: [],
      packageCounts: {},
    };
  },
  mounted() {
    this.getAllPackage();
  },
  methods: {
    getAllPackage() {
      http
        .get("/v1/admin/getAllPackage", {
          headers: { adminToken: localStorage.getItem("adminToken") },
        })
        .then((res) => {
          if (res.data.code != 200) {
            this.$notify({
              type: "danger",
              message: res.data.message,
              timeout: 2000,
              icon: "tim-icons icon-bell-55",
            });
            return;
          }
          this.tableData = res.data.data.packageData;
          let siteDataArr = [];
          res.data.data.siteData.forEach((element) => {
            siteDataArr.push({
              value: element.id,
              label: element.name,
            });
          });
          this.selects1.languages = siteDataArr;
        })
        .catch((error) => {
          console.error("发生错误:", error);
          // 或者将错误状态存储到Vue组件中的数据中，并在页面上显示友好的提示
        });
    },
    handleAddPackage() {
      this.modals = true;
    },
    doAddPackage() {
      let packageArr = []; // 套餐网站对应次数
      this.selects1.multiple.forEach((element) => {
        let packageObj = {
          siteId: element.value,
          num: this.packageCounts[element.value],
        };
        if (packageObj.num <= 0 || packageObj.num == undefined) {
          this.$notify({
            type: "danger",
            message: "套餐次数不能为空",
            timeout: 2000,
            icon: "tim-icons icon-bell-55",
          });
          return;
        }
        packageArr.push(packageObj);
      });
      if (
        this.packageName == "" ||
        this.packageDuration == "" ||
        this.packagePrice == "" ||
        this.selects.simple == ""
      ) {
        this.$notify({
          type: "danger",
          message: "参数不能为空",
          timeout: 2000,
          icon: "tim-icons icon-bell-55",
        });
        return;
      }

      if (packageArr.length <= 0) {
        this.$notify({
          type: "danger",
          message: "套餐对应网站不能为空",
          timeout: 2000,
          icon: "tim-icons icon-bell-55",
        });
        return;
      }
      http
        .post(
          "/v1/admin/addPackage",
          {
            siteNum: this.siteNum,
            packageName: this.packageName,
            packageDuration: this.packageDuration,
            packagePrice: this.packagePrice,
            packageType: this.selects.simple,
            cdkType: this.selects3.simple,
            vipType: this.selects5.simple,
            packageArr: JSON.stringify(packageArr),
          },
          { headers: { adminToken: localStorage.getItem("adminToken") } }
        )
        .then((res) => {
          if (res.data.code != 200) {
            this.$notify({
              type: "danger",
              message: res.data.message,
              timeout: 2000,
              icon: "tim-icons icon-bell-55",
            });
            return;
          }
          this.modals = false;
          this.tableData = res.data.data.packageData;
          let siteDataArr = [];
          res.data.data.siteData.forEach((element) => {
            siteDataArr.push({
              value: element.id,
              label: element.name,
            });
          });
          this.selects1.languages = siteDataArr;
          Swal.fire({
            icon: "success",
            html: "套餐添加成功",
            customClass: {
              confirmButton: "btn btn-success btn-fill",
            },
            buttonsStyling: false,
          });
        })
        .catch((error) => {
          console.error("发生错误:", error);
          // 或者将错误状态存储到Vue组件中的数据中，并在页面上显示友好的提示
        });
    },
    // 更新代理提卡状态
    updateAgentState(row) {
      http
        .post(
          "/v1/admin/updateAgentState",
          {
            packageId: row.id,
          },
          { headers: { adminToken: localStorage.getItem("adminToken") } }
        )
        .then((res) => {
          if (res.data.code != 200) {
            Swal.fire({
              icon: "error",
              title: "更改代理提卡状态失败",
              text: res.data.message,
              customClass: {
                confirmButton: "btn btn-success btn-fill",
              },
              buttonsStyling: false,
            });
                this.getAllPackage()
            return;
          }
          this.getAllPackage()
          Swal.fire({
            icon: "success",
            html: "更新代理提卡状态成功",
            customClass: {
              confirmButton: "btn btn-success btn-fill",
            },
            buttonsStyling: false,
          });
        })
        .catch((error) => {
          console.error("发生错误:", error);
          // 或者将错误状态存储到Vue组件中的数据中，并在页面上显示友好的提示
        });
    },
    //更新套餐对应网站状态
    updataPackageSiteState(packageSiteId) {
      http
        .post(
          "/v1/admin/updatePackageSitestate",
          {
            packageId: this.packageId,
            packageSiteId: packageSiteId,
          },
          { headers: { adminToken: localStorage.getItem("adminToken") } }
        )
        .then((res) => {
          if (res.data.code != 200) {
            Swal.fire({
              icon: "error",
              title: "更改更新套餐对应网站状态失败",
              text: res.data.message,
              customClass: {
                confirmButton: "btn btn-success btn-fill",
              },
              buttonsStyling: false,
            });
            return;
          }
          this.updatePackageList = res.data.data;
          Swal.fire({
            icon: "success",
            html: "更新套餐对应网站状态成功",
            customClass: {
              confirmButton: "btn btn-success btn-fill",
            },
            buttonsStyling: false,
          });
        })
        .catch((error) => {
          console.error("发生错误:", error);
          // 或者将错误状态存储到Vue组件中的数据中，并在页面上显示友好的提示
        });
    },
    changePackageState(id) {
      http
        .post(
          "/v1/admin/changePackageState",
          {
            packageId: id,
          },
          { headers: { adminToken: localStorage.getItem("adminToken") } }
        )
        .then((res) => {
          if (res.data.code != 200) {
            Swal.fire({
              icon: "error",
              title: "更改套餐状态失败",
              text: res.data.message,
              customClass: {
                confirmButton: "btn btn-success btn-fill",
              },
              buttonsStyling: false,
            });
            return;
          }
          this.tableData = res.data.data.packageData;
          let siteDataArr = [];
          res.data.data.siteData.forEach((element) => {
            siteDataArr.push({
              value: element.id,
              label: element.name,
            });
          });
          this.selects1.languages = siteDataArr;
          Swal.fire({
            icon: "success",
            html: "更改套餐状态成功",
            customClass: {
              confirmButton: "btn btn-success btn-fill",
            },
            buttonsStyling: false,
          });
        })
        .catch((error) => {
          console.error("发生错误:", error);
          // 或者将错误状态存储到Vue组件中的数据中，并在页面上显示友好的提示
        });
    },
    editPackage(id, name, siteNum, duration, price, package_type, cdk_type,vip_type) {
      this.modals1 = true;
      this.editPackageName = name;
      this.editSiteNum = siteNum;
      this.editPackageDuration = duration;
      this.editPackagePrice = price;
      this.selects2.simple = package_type + "";
      this.selects4.simple = cdk_type + "";
      this.selects5.simple = vip_type + "";
      this.packageId = id;
      http
        .post(
          "/v1/admin/getUpdatePackage",
          {
            packageId: id,
          },
          { headers: { adminToken: localStorage.getItem("adminToken") } }
        )
        .then((res) => {
          if (res.data.code != 200) {
            this.$notify({
              type: "danger",
              message: "获取更新套餐列表失败",
              timeout: 2000,
              icon: "tim-icons icon-bell-55",
            });
            return;
          }
          this.updatePackageList = res.data.data;
        })
        .catch((error) => {
          console.error("发生错误:", error);
          // 或者将错误状态存储到Vue组件中的数据中，并在页面上显示友好的提示
        });
    },
    doEditPackage() {
      http
        .post(
          "/v1/admin/doUpdatePackage",
          {
            packageName: this.editPackageName,
            packageDuration: this.editPackageDuration,
            packagePrice: this.editPackagePrice,
            packageType: this.selects2.simple,
            cdkType: this.selects4.simple,
            vipType: this.selects5.simple,
            packageId: this.packageId,
            siteNum: this.editSiteNum,
            packageArr: JSON.stringify(this.updatePackageList),
          },
          { headers: { adminToken: localStorage.getItem("adminToken") } }
        )
        .then((res) => {
          if (res.data.code != 200) {
            this.$notify({
              type: "danger",
              message: res.data.message,
              timeout: 2000,
              icon: "tim-icons icon-bell-55",
            });
            return;
          }
          this.modals1 = false;
          this.tableData = res.data.data.packageData;
          let siteDataArr = [];
          res.data.data.siteData.forEach((element) => {
            siteDataArr.push({
              value: element.id,
              label: element.name,
            });
          });
          this.selects1.languages = siteDataArr;
          Swal.fire({
            icon: "success",
            title: "更新套餐",
            text: res.data.message,
            customClass: {
              confirmButton: "btn btn-success btn-fill",
            },
            buttonsStyling: false,
          });
        })
        .catch((error) => {
          console.error("发生错误:", error);
          // 或者将错误状态存储到Vue组件中的数据中，并在页面上显示友好的提示
        });
    },
  },
  watch: {
    selectedPackages(newVal, oldVal) {
      oldVal.forEach((pkg) => {
        if (!newVal.includes(pkg)) {
          this.$delete(this.packageCounts, pkg);
        }
      });
      newVal.forEach((pkg) => {
        if (!this.packageCounts[pkg]) {
          this.$set(this.packageCounts, pkg, 1);
        }
      });
    },
  },
};
</script>
<style scoped>
.modal-content {
  width: 800px;
}
</style>



 